<template>
  <div class="login">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
      @submit.native.prevent="handleSubmit2"
    >
      <h3 class="title">荞麦留学后台登录</h3>
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          type="password"
          v-model="ruleForm2.checkPass"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" native-type="submit" :loading="logining">登录</el-button>
        <!-- <el-button @click.native.prevent="handleReset2">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import user from "@/plugins/user.js";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    //验证码确认验证码处理
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
      },
      rules2: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          //{ validator: validaePass }
        ],
        checkPass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          //{ validator: validaePass2 }
        ],
      },
      checked: true,
    };
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2(ev) {
      let _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
          };
          //提交后台验证是否可以登录
          var link = url.getAccount("check");
          $.post(link, loginParams, (res) => {
            _this.logining = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
              var info = JSON.parse(res.data.info);
              info.checked = _this.checked;
              user.save(info);
              
              _this.$router.replace("/");
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    // $.get('http://manage.riheliuxue.com/api/sys/GetCurrent_Nav',{},res=>{
    //   console.info(res);
    // });

    // $.ajax({
    //   xhrFields: {
    //     withCredentials: true, //支持附带详细信息
    //     "Sec-Fetch-Mode": "cors",
    //   },
    //   crossDomain: true, //请求偏向外域
    //   url: url.getSys("GetCurrent_Nav"),
    //   success: (res) => {
    //     console.info(res);
    //   },
    // });

    // var link = url.getSys("GetCurrent_Nav");
    // var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    // xhr.open("PUT", link, true);
    // xhr.send();

    // $.cookie('user','1234');
    // console.info(document.cookie);
  },
};
</script>

<style >
.login {
  background: linear-gradient(to right, #0168cf, #409eff, #0168cf);
  background-image: url(../assets/back.jpg);
  background-position: center right;
  background-size: cover;
  height: 100%;
  clear: both;
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 0px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
</style>